import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import { Cushion, Space, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import WebsiteListItem from './website-list-item';

const WebsiteList = ({ clubs, leagueWebsites }) => {
  const hasClubs = !isEmpty(clubs);
  const hasLeagues = !isEmpty(leagueWebsites);
  if (!hasClubs && !hasLeagues) {
    return null;
  }

  return (
    <div style={{ flex: 1 }}>
      {hasClubs && (
        <>
          <Cushion bottom="medium">
            <Typography preset="tag--large" color="black" component="div">
              <Trans i18nKey="common:network_panel_website_list_clubs_header">
                View Club Websites
              </Trans>
            </Typography>
          </Cushion>
          {map(clubs, (club) => (
            <Space vertical="xsmall" key={club.id}>
              <a href={club.url} title={club.name} aria-label={club.name}>
                <WebsiteListItem website={club} />
              </a>
            </Space>
          ))}
        </>
      )}
      {hasLeagues && (
        <>
          <Cushion bottom="medium">
            <Typography preset="tag--large" color="black" component="div">
              <Trans i18nKey="common:network_panel_website_list_leagues_header">
                View League Websites
              </Trans>
            </Typography>
          </Cushion>

          {map(leagueWebsites, (league) => (
            <Space vertical="xsmall" key={league.id}>
              <a href={league.url} title={league.name} aria-label={league.name}>
                <WebsiteListItem website={league} />
              </a>
            </Space>
          ))}
        </>
      )}
    </div>
  );
};

WebsiteList.propTypes = {
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
  leagueWebsites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
};

export default WebsiteList;
